import {EmbeddedBlock, ReadBuyer} from '@tinct/core-api-models';
import {ScrollArea} from '@tinct/web-components';
import {
  LargeLogosToggle,
  LogoColorModeSection,
  SidebarGroupLabel,
  SocialProofLogosSection,
} from './block-sections';

type BlockDetailsSidebarProps = {
  block: EmbeddedBlock;
  onBlockUpdate?: (block: EmbeddedBlock) => void;
  organizationId?: string;
  /** Called after a buyer is removed from the customers library. */
  onBuyerRemoved?: (buyer: ReadBuyer) => void;
};

/**
 * Logo (social proof) block settings. Every other block is edited inline in
 * its badge (see BlockBadges); the AI-personalization switch lives there for
 * logo blocks too, so this sidebar only holds the logo-specific settings.
 */
export const BlockDetailsSidebar = ({
  block,
  onBlockUpdate,
  organizationId,
  onBuyerRemoved
}: BlockDetailsSidebarProps) => (
  <ScrollArea className="h-full w-full">
    <div className="flex flex-col gap-4 p-4">
      <div className="flex flex-col">
        <SidebarGroupLabel label="Content" />
        <div className="flex flex-col gap-3">
          <LogoColorModeSection block={block} onBlockUpdate={onBlockUpdate} />
          <div className="flex flex-col overflow-hidden rounded-2xl bg-secondary">
            <LargeLogosToggle block={block} onBlockUpdate={onBlockUpdate} />
          </div>
        </div>
      </div>

      <SocialProofLogosSection
        organizationId={organizationId}
        block={block}
        onBuyerRemoved={onBuyerRemoved}
      />
    </div>
  </ScrollArea>
);
